// @flow

import env from '../../../environment';
import {getCreator, postCreator} from '../../../http';

export type ReportRequest = {
  trackingId?: string,
};

export const endpoints = Object.freeze({
  GET_GA_INTEGRATION: `${env.baseApiUrl}/ui/admin/store/google-analytics-integration`,
  GET_GTM_INTEGRATION: `${env.baseApiUrl}/ui/admin/google-tag-manager`,
});

export const getGAIntegrationApi = getCreator(endpoints.GET_GA_INTEGRATION);
export const updateGAIntegrationApi = postCreator(endpoints.GET_GA_INTEGRATION);

export const setGTMIntegrationApi = postCreator(endpoints.GET_GTM_INTEGRATION);
export const getGTMIntegrationApi = getCreator(endpoints.GET_GTM_INTEGRATION);
